import Actions from './blacklist-actions';
import Api from './blacklist-api';
import reducer from './blacklist-reducer';
import sagas from './blacklist-sagas';
import Selectors from './blacklist-selectors';

export default {
  Actions,
  Api,
  namespace: 'blacklist',
  reducer,
  sagas:     [sagas],
  Selectors,
};
